import React from 'react';

import Link from 'buyside/components/presentation/Link/link';
import ParsedHtml from 'buyside/components/presentation/ParsedHtml/parsedHtml';

import styles from 'buyside/components/presentation/ContestShowPage/ContestPrizes/contestPrizesStyles.scss';

const ContestPrizes = ({ prizes }) => {
  return (
    <>
      {prizes.map(({ id, description, sponsorImage, sponsorTrackingLink }) => (
        <div key={id}>
          <ParsedHtml html={description}>{({ content }) => <div>{content}</div>}</ParsedHtml>
          {sponsorImage && (
            <div className={styles.prizeSponsor}>
              <strong>Provided by: </strong>
              <div className={styles.sponsorImageWrapper}>
                <Link to={sponsorTrackingLink}>
                  <img alt="sponsorImage" src={sponsorImage} />
                </Link>
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default ContestPrizes;
